import { MapPin, Plane, Ship, Users } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { LOCATIONS } from "@/lib/site-data";

const VALUES = [
  { icon: Plane, label: "Air cargo 3× weekly" },
  { icon: Ship, label: "Sea freight weekly" },
  { icon: Users, label: "Family-first service" },
];

export default function About() {
  return (
    <section id="about" className="relative py-24 sm:py-32">
      <div className="pointer-events-none absolute -left-24 top-1/3 h-[360px] w-[360px] glow-purple" />
      <div className="relative mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div>
              <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
                <span className="h-px w-8 bg-[#E31B23]" /> About us
              </div>
              <h2 className="font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
                You order, we deliver.
              </h2>
              <div className="mt-5 space-y-4 text-[#4b5563] leading-relaxed">
                <p>
                  XPRESSNGOSHIP LTD — <span className="font-semibold text-[#1F1F1F]">Xpress N' Go Ship</span> — is a
                  premium shipping company connecting Jamaica to the world. From our overseas gateway we ship air
                  cargo three times a week and sea freight weekly, handling sourcing, consolidation, courier packing
                  and customs so you don't have to.
                </p>
                <p>
                  We don't just manage suppliers — we micro-manage them. Every package gets the same care we'd want
                  for our own family, which is exactly how our customers say it feels.
                </p>
              </div>

              <div className="mt-8 flex flex-wrap gap-3">
                {VALUES.map((v) => (
                  <div key={v.label} className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2 text-sm font-medium text-[#1F1F1F]">
                    <v.icon size={15} className="text-[#5A189A]" /> {v.label}
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div>
              <h3 className="font-display text-lg font-bold text-[#1F1F1F]">Our branches</h3>
              <p className="mt-1 text-sm text-[#9ca3af]">Come see us in person — we're happy to help.</p>
              <div className="mt-5 space-y-4">
                {LOCATIONS.map((loc, i) => (
                  <div key={i} data-testid={`location-${i}`}
                    className="flex items-start gap-4 rounded-2xl border border-black/5 bg-white p-5 shadow-[0_10px_30px_-22px_rgba(17,24,39,0.35)]">
                    <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[#5A189A]/10">
                      <MapPin size={18} className="text-[#5A189A]" />
                    </span>
                    <div>
                      <div className="font-display text-base font-bold text-[#1F1F1F]">{loc.name}</div>
                      <p className="mt-1 text-sm leading-relaxed text-[#4b5563]">{loc.address}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
